import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useInsertData } from "../../hooks/useInsertData";
import { useGetData } from "../../hooks/useGetData";
import { useUpdateData } from "../../hooks/useUpdateDate";
import useDeleteData from "../../hooks/useDeleteData";

export const createMaintenanceSchedule = createAsyncThunk(
  "maintenanceSchedule/createMaintenanceSchedule",
  async (data, { rejectWithValue }) => {
    try {
      const res = await useInsertData("maintenanceSchedules", data);
      return res.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  },
);

export const getAllMaintenanceSchedule = createAsyncThunk(
  "maintenanceSchedule/getAllMaintenanceSchedule",
  async (page = 1, { rejectWithValue }) => {
    try {
      const res = await useGetData(`maintenanceSchedules?page=${page}`);
      return res;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  },
);

// ✅ جديد - جلب كل البيانات للبحث المحلي
export const getAllMaintenanceScheduleForSearch = createAsyncThunk(
  "maintenanceSchedule/getAllMaintenanceScheduleForSearch",
  async (_, { rejectWithValue }) => {
    try {
      // جلب كل البيانات بـ page=0
      const res = await useGetData(`maintenanceSchedules?page=0`);
      return res;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  },
);

export const getAllMaintenanceScheduleById = createAsyncThunk(
  "maintenanceSchedule/getAllMaintenanceScheduleById",
  async (id, { rejectWithValue }) => {
    try {
      const res = await useGetData(`maintenanceSchedules/${id}`);
      return res.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  },
);

export const assignTechnician = createAsyncThunk(
  "maintenanceSchedule/assignTechnician",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await useUpdateData(
        `maintenanceSchedules/assignTechnician/${id}`,
        data,
      );
      return res.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  },
);

export const assignMangerAndStuffContract = createAsyncThunk(
  "contracts/assignMangerAndStuff",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await useUpdateData(
        `maintenanceSchedules/assign-schedules/${id}`,
        data,
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const assignMangerAndStuffSingleShedule = createAsyncThunk(
  "contracts/assignMangerAndStuffSingleShedule",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await useUpdateData(
        `maintenanceSchedules/assign/${id}`,
        data,
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const updateMaintenanceSchedule = createAsyncThunk(
  "maintenanceSchedule/updateSchedule",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await useUpdateData(`maintenanceSchedules/${id}`, data);
      return res.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  },
);

export const getAllMyTasks = createAsyncThunk(
  "maintenanceSchedule/getAllMyTasks",
  async (page = 1, { rejectWithValue }) => {
    try {
      const res = await useGetData(
        `maintenanceSchedules/assignedSchedules?page=` + page,
      );
      console.log(res);
      return res;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  },
);

export const deleteMainTenanceSchedule = createAsyncThunk(
  "maintenanceSchedule/deleteMainTenanceSchedule",
  async (id, { rejectWithValue }) => {
    try {
      const res = await useDeleteData(`maintenanceSchedules/force/${id}`);
      return res.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  },
);

export const getMaintenanceStatistics = createAsyncThunk(
  "maintenanceSchedule/getMaintenanceStatistics",
  async (params = {}, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();

      if (params.period) queryParams.append("period", params.period);
      if (params.start_date)
        queryParams.append("start_date", params.start_date);
      if (params.end_date) queryParams.append("end_date", params.end_date);
      if (params.has_fire_extinguishers !== undefined) {
        queryParams.append(
          "has_fire_extinguishers",
          params.has_fire_extinguishers,
        );
      }
      if (params.status) queryParams.append("status", params.status);
      if (params.priority) queryParams.append("priority", params.priority);

      const queryString = queryParams.toString();
      const endpoint = queryString
        ? `maintenanceSchedules/statistics?${queryString}`
        : `maintenanceSchedules/statistics`;

      const res = await useGetData(endpoint);
      return res.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  },
);

// إبقاء الـ searchMaintenanceSchedules للـ API (احتياطي)
export const searchMaintenanceSchedules = createAsyncThunk(
  "maintenanceSchedule/searchMaintenanceSchedules",
  async ({ keyword, page = 1 }, { rejectWithValue }) => {
    try {
      const res = await useGetData(
        `maintenanceSchedules?keyword=${encodeURIComponent(
          keyword,
        )}&page=${page}`,
      );
      return res;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  },
);

const initialState = {
  maintenanceSchedule: null,
  allMaintenanceSchedule: null,
  allDataForSearch: null, // ✅ جديد - كل البيانات للبحث
  specificMaintenanceSchedule: null,
  allMyTasks: null,
  statistics: null,
  searchResults: null,
  status: "idle",
  searchStatus: "idle",
  searchDataStatus: "idle", // ✅ جديد
  error: null,
  token: null,
};

export const maintenanceScheduleSlice = createSlice({
  name: "MaintenanceSchedule",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(createMaintenanceSchedule.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(createMaintenanceSchedule.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.maintenanceSchedule = action.payload;
      })
      .addCase(createMaintenanceSchedule.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(getAllMaintenanceSchedule.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getAllMaintenanceSchedule.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allMaintenanceSchedule = action.payload;
      })
      .addCase(getAllMaintenanceSchedule.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // ✅ جديد - للبحث المحلي
      .addCase(getAllMaintenanceScheduleForSearch.pending, (state) => {
        state.searchDataStatus = "loading";
        state.error = null;
      })
      .addCase(
        getAllMaintenanceScheduleForSearch.fulfilled,
        (state, action) => {
          state.searchDataStatus = "succeeded";
          state.allDataForSearch = action.payload;
        },
      )
      .addCase(getAllMaintenanceScheduleForSearch.rejected, (state, action) => {
        state.searchDataStatus = "failed";
        state.error = action.payload;
      })
      .addCase(getAllMaintenanceScheduleById.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getAllMaintenanceScheduleById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.specificMaintenanceSchedule = action.payload;
      })
      .addCase(getAllMaintenanceScheduleById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(assignTechnician.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(assignTechnician.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(assignTechnician.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(getAllMyTasks.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getAllMyTasks.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allMyTasks = action.payload;
      })
      .addCase(getAllMyTasks.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(updateMaintenanceSchedule.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateMaintenanceSchedule.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(updateMaintenanceSchedule.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(deleteMainTenanceSchedule.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(deleteMainTenanceSchedule.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(action.payload);
      })
      .addCase(deleteMainTenanceSchedule.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(getMaintenanceStatistics.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getMaintenanceStatistics.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.statistics = action.payload;
      })
      .addCase(getMaintenanceStatistics.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(searchMaintenanceSchedules.pending, (state) => {
        state.searchStatus = "loading";
        state.error = null;
      })
      .addCase(searchMaintenanceSchedules.fulfilled, (state, action) => {
        state.searchStatus = "succeeded";
        state.searchResults = action.payload;
      })
      .addCase(searchMaintenanceSchedules.rejected, (state, action) => {
        state.searchStatus = "failed";
        state.error = action.payload;
      });
  },
});

export default maintenanceScheduleSlice.reducer;
